// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CollateralAgreement } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Collateral/module';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useCallVariationMargin = () => {
  const { submit } = useExerciseSubmission(
    CollateralAgreement.CollateralAgreement_CallVariationMargin,
    'Successfully called variation margin',
    'Failed to call variation margin',
  );
  return submit;
};
